import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { EnvironmentProviders, Provider, inject, provideEnvironmentInitializer } from '@angular/core';
import { authInterceptor, unauthErrorInterceptor } from 'app/core/auth/auth.interceptor';
import { AuthService } from 'app/core/auth/auth.service';

export const provideAuth = (): (Provider | EnvironmentProviders)[] => {
    return [
        provideHttpClient(withInterceptors([authInterceptor, unauthErrorInterceptor])),
        provideEnvironmentInitializer(() => inject(AuthService)),
    ];
};
